import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Slide,
  useScrollTrigger,
} from "@mui/material"
import { FC, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { useAppDispatch } from "../../app/hooks"
import { useIsAuthorizedUser } from "../../hooks/useIsAuthorizedUser"
import { show as showCreateEvent } from "../../pages/makeEvent/slice/MakeEventSlice"
import { show } from "../../pages/signIn/SignInSlice"
import PrivacyLinks from "@components/PrivacyLinks"
import { footerCont, footerNav, footerNavItem } from "./footerStyle"

import CreateIcon from "@mui/icons-material/AddOutlined"
import ChatIcon from "@mui/icons-material/ChatBubbleOutlineOutlined"
import FavoriteIcon from "@mui/icons-material/FavoriteBorderOutlined"
import HomeIcon from "@mui/icons-material/HomeOutlined"
import UserIcon from "@mui/icons-material/PersonOutlineOutlined"

const Footer: FC = () => {
  const trigger = useScrollTrigger()
  const isAuth = useIsAuthorizedUser()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [activeNav, setActiveNav] = useState<string | null>(
    window.location.hash.slice(1) || "/",
  )

  const navLinks = [
    { path: "/", icon: HomeIcon, label: "Главная" },
    //{ path: "/favorites", icon: FavoriteIcon, label: "Избранное" },
    { path: "/create", icon: CreateIcon },
    //{ path: "/chat", icon: ChatIcon, label: "Чат" },
    { path: "/profile", icon: UserIcon, label: "Профиль" },
  ]

  const handleNavigationChange = (
    event: React.SyntheticEvent,
    newPath: string,
  ) => {
    setActiveNav(newPath)
    if (!isAuth && newPath !== "/") {
      dispatch(show())
    } else if (newPath === "/create") {
      dispatch(showCreateEvent())
    } else {
      navigate(newPath)
    }
  }

  useEffect(() => {
    setActiveNav(
      window.location.hash.includes("profile")
        ? "/profile"
        : window.location.hash.slice(1) || "/",
    )
  }, [window.location.hash])

  return (
    <footer>
      <PrivacyLinks />
      <Slide appear={false} direction="up" in={!trigger}>
        <Paper sx={footerCont}>
          <BottomNavigation
            sx={footerNav}
            showLabels
            value={activeNav}
            onChange={handleNavigationChange}
          >
            {navLinks.map(({ path, icon: Icon, label }) => (
              <BottomNavigationAction
                key={path}
                sx={footerNavItem}
                value={path}
                icon={<Icon />}
                label={label || ""}
              />
            ))}
          </BottomNavigation>
        </Paper>
      </Slide>
    </footer>
  )
}

export default Footer
